import { TeamType } from '@mediacoach/ui'
import { PeriodEnum } from '@core/enums/period.enums'

export const TEAMS = [TeamType.Home, TeamType.Away]
export const PERIODS = [
  PeriodEnum.First,
  PeriodEnum.Second,
  PeriodEnum.ExtraFirst,
  PeriodEnum.ExtraSecond,
  PeriodEnum.Penalties,
  PeriodEnum.End
]
